











































import Vue, { PropType } from 'vue';
// import { toDate } from '@/modules/calender';
import { calender } from 'mostra';
import { FirestoreDate } from '@/modules/firestore';
import { extend } from 'vee-validate';
import moment from 'moment-timezone';
// import moment from 'moment';
// import 'moment-timezone';

export type DataType = {
  innerStartValue: Date | string | null;
  innerEndValue: Date | string | null;
  duplicateError: boolean;
  coupleValueError: boolean;
  formatErrorStartValue: boolean;
  formatErrorEndValue: boolean;
};

const dateFormatRegex = /^(\d{4})\/(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/;

extend('dateRangeStart', {
  params: ['date'],
  validate(value, params: any) {
    const { date } = params;
    if (!date) return true;
    const startDate = new Date(value);
    const endDate = new Date(date);
    return startDate.getTime() <= endDate.getTime();
  },
});

extend('dateRangeEnd', {
  params: ['date'],
  validate(value, params: any) {
    const { date } = params;
    if (!date) return true;
    const startDate = new Date(date);
    const endDate = new Date(value);
    return startDate.getTime() <= endDate.getTime();
  },
});

extend('formatDate', {
  validate(value) {
    let val = value;
    if (typeof value === 'object') val = moment(value).format('YYYY/MM/DD');
    return dateFormatRegex.test(val);
  },
});

extend('checkCoupleValue', {
  params: ['date'],
  validate(value, params: any) {
    const { date } = params;
    if (!value && !date) return true;
    let value1 = value;
    let value2 = date;
    if (typeof value === 'object') value1 = moment(value).format('YYYY/MM/DD');
    if (typeof date === 'object') value2 = moment(date).format('YYYY/MM/DD');
    return dateFormatRegex.test(value1) && dateFormatRegex.test(value2);
  },
});

export default Vue.extend({
  name: 'GDatePickFormInput',
  props: {
    isLabel: { type: Boolean as PropType<boolean>, default: true },
    isTag: { type: Boolean as PropType<boolean>, default: false },
    isPublic: { type: Boolean as PropType<boolean>, default: false },
    exclamation: { type: Array as PropType<string[]>, default: () => [] },
    label: { type: String as PropType<string>, default: null },
    isRequired: { type: Boolean as PropType<boolean>, default: false },
    startValue: {
      type: [Date, Object] as PropType<FirestoreDate>,
      default: null,
    },
    endValue: {
      type: [Date, Object] as PropType<FirestoreDate>,
      default: null,
    },
    startName: { type: String as PropType<string>, required: true },
    endName: { type: String as PropType<string>, required: true },
    // startDisabled: { type: Boolean as PropType<boolean>, default: false },
    // endDisabled: { type: Boolean as PropType<boolean>, default: false },
  },
  data(): DataType {
    return {
      innerStartValue: this.startValue ? calender.toDate(this.startValue) : null,
      innerEndValue: this.endValue ? calender.toDate(this.endValue) : null,
      duplicateError: false,
      coupleValueError: false,
      formatErrorStartValue: false,
      formatErrorEndValue: false,
    };
  },
  watch: {
    innerStartValue(val: string) {
      this.validateCoupleValue();
      this.formatErrorStartValue = !this.validateDateFormat(val);
      if (!this.validateDateFormat(val) === true) return;
      this.$emit('startInput', val === '' ? null : new Date(val));
      if (this.innerStartValue && this.innerEndValue) this.validateDuplicateDate();
    },
    innerEndValue(val: string) {
      this.validateCoupleValue();
      this.formatErrorEndValue = !this.validateDateFormat(val);
      if (!this.validateDateFormat(val) === true) return;
      this.$emit('endInput', val === '' ? null : new Date(val));
      if (this.innerStartValue && this.innerEndValue) this.validateDuplicateDate();
    },
  },
  methods: {
    validateDuplicateDate() {
      if (this.innerStartValue === null || this.innerEndValue === null) return;
      let isStartValue = false;
      let isEndValue = false;
      if (typeof this.innerStartValue === 'string') {
        isStartValue = dateFormatRegex.test(this.innerStartValue);
      }
      if (typeof this.innerStartValue === 'object') {
        isStartValue = true;
      }
      if (typeof this.innerEndValue === 'string') {
        isEndValue = dateFormatRegex.test(this.innerEndValue);
      }
      if (typeof this.innerEndValue === 'object') {
        isEndValue = true;
      }
      if (isStartValue && isEndValue) {
        const startValue = new Date(this.innerStartValue);
        const endValue = new Date(this.innerEndValue);
        this.duplicateError = startValue.getTime() > endValue.getTime();
      }
    },
    validateCoupleValue() {
      if (this.isRequired) {
        this.coupleValueError = false;
        return;
      }
      if (!this.innerStartValue && !this.innerEndValue) {
        this.coupleValueError = false;
        return;
      }
      let value1 = this.innerStartValue;
      let value2 = this.innerEndValue;
      if (typeof value1 === 'object') value1 = moment(this.innerStartValue).format('YYYY/MM/DD');
      if (typeof value2 === 'object') value2 = moment(this.innerEndValue).format('YYYY/MM/DD');
      this.coupleValueError = !(dateFormatRegex.test(value1) && dateFormatRegex.test(value2));
    },
    validateDateFormat(value: string) {
      if (!value) return true;
      return dateFormatRegex.test(value);
    },
    getStartValue(val: string) {
      this.duplicateError = false;
      this.innerStartValue = val;
    },
    getEndValue(val: string) {
      this.duplicateError = false;
      this.innerEndValue = val;
    },
  },
  mounted() {
    if (this.innerStartValue || this.innerEndValue) {
      this.validateCoupleValue();
      this.validateDuplicateDate();
    }
  },
});
